<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iKhQIl/tc-custom/9781035825059.jpg?1718106146971" alt="This image is the cover for the book Wester Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wester Island
      </h1>
      <p class="bookDescription body article font2">
        <p>In an unprecedented venture, the world’s richest man turns a remote island into a live social experiment and reality show. It attracts a diverse group pursuing extraordinary goals: private visionaries, scientists, and military figures, all operating beyond mainland constraints. As the world watches, global tensions escalate towards war. <br/>Key players include Bonita Apple in the communist camp, Samson Tunn from Space Force testing new technologies, and local Sevi Akonga striving to preserve the island’s heritage. From a mainland cave, Jonah Smith narrates these events as the world teeters on the brink of chaos, offering a riveting glimpse into ambition, power, and the fragility of societal order.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew McKenzie
      </h2>
      
      <p class="authorDescription body article">Andrew grew up in rural Hawkes Bay on an orchard and his interest in music took him to Wellington where he lived for twelve years as a musician. He moved back to the family property to look after his mother in her later years and a publishing deal with Ford NZ for one of his songs allowed a year off work and the writing of Wester Island. This time included travel to Egypt and some of the book was written there.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?759b8f6a